<wl-partial-card [shadow]="false">
  <ng-container slot="header">
    <div class="d-flex mb-1">
      <p class="flex-grow-1 m-0 pe-2 fw-bold">{{ title }}</p>
      <ng-content select="[slot='action']"></ng-content>
    </div>
  </ng-container>
  <ng-container slot="content">
    <div>
      <ng-content select="[slot='content']"></ng-content>
    </div>
  </ng-container>
</wl-partial-card>
